import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import e from "../core/Plugin";
import t from "../utils/classSet";
import s from "../utils/closest";
import i from "./Message";

var l = /*#__PURE__*/function (_e) {
  _inherits(l, _e);

  var _super = _createSuper(l);

  function l(e) {
    var _this;

    _classCallCheck(this, l);

    _this = _super.call(this, e);
    _this.results = new Map();
    _this.containers = new Map();
    _this.opts = Object.assign({}, {
      defaultMessageContainer: true,
      eleInvalidClass: "",
      eleValidClass: "",
      rowClasses: "",
      rowValidatingClass: ""
    }, e);
    _this.elementIgnoredHandler = _this.onElementIgnored.bind(_assertThisInitialized(_this));
    _this.elementValidatingHandler = _this.onElementValidating.bind(_assertThisInitialized(_this));
    _this.elementValidatedHandler = _this.onElementValidated.bind(_assertThisInitialized(_this));
    _this.elementNotValidatedHandler = _this.onElementNotValidated.bind(_assertThisInitialized(_this));
    _this.iconPlacedHandler = _this.onIconPlaced.bind(_assertThisInitialized(_this));
    _this.fieldAddedHandler = _this.onFieldAdded.bind(_assertThisInitialized(_this));
    _this.fieldRemovedHandler = _this.onFieldRemoved.bind(_assertThisInitialized(_this));
    _this.messagePlacedHandler = _this.onMessagePlaced.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(l, [{
    key: "install",
    value: function install() {
      var _t,
          _this2 = this;

      t(this.core.getFormElement(), (_t = {}, _defineProperty(_t, this.opts.formClass, true), _defineProperty(_t, "fv-plugins-framework", true), _t));
      this.core.on("core.element.ignored", this.elementIgnoredHandler).on("core.element.validating", this.elementValidatingHandler).on("core.element.validated", this.elementValidatedHandler).on("core.element.notvalidated", this.elementNotValidatedHandler).on("plugins.icon.placed", this.iconPlacedHandler).on("core.field.added", this.fieldAddedHandler).on("core.field.removed", this.fieldRemovedHandler);

      if (this.opts.defaultMessageContainer) {
        this.core.registerPlugin("___frameworkMessage", new i({
          clazz: this.opts.messageClass,
          container: function container(e, t) {
            var _l = "string" === typeof _this2.opts.rowSelector ? _this2.opts.rowSelector : _this2.opts.rowSelector(e, t);

            var a = s(t, _l);
            return i.getClosestContainer(t, a, _this2.opts.rowPattern);
          }
        }));
        this.core.on("plugins.message.placed", this.messagePlacedHandler);
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      var _t2;

      this.results.clear();
      this.containers.clear();
      t(this.core.getFormElement(), (_t2 = {}, _defineProperty(_t2, this.opts.formClass, false), _defineProperty(_t2, "fv-plugins-framework", false), _t2));
      this.core.off("core.element.ignored", this.elementIgnoredHandler).off("core.element.validating", this.elementValidatingHandler).off("core.element.validated", this.elementValidatedHandler).off("core.element.notvalidated", this.elementNotValidatedHandler).off("plugins.icon.placed", this.iconPlacedHandler).off("core.field.added", this.fieldAddedHandler).off("core.field.removed", this.fieldRemovedHandler);

      if (this.opts.defaultMessageContainer) {
        this.core.off("plugins.message.placed", this.messagePlacedHandler);
      }
    }
  }, {
    key: "onIconPlaced",
    value: function onIconPlaced(e) {}
  }, {
    key: "onMessagePlaced",
    value: function onMessagePlaced(e) {}
  }, {
    key: "onFieldAdded",
    value: function onFieldAdded(e) {
      var _this3 = this;

      var s = e.elements;

      if (s) {
        s.forEach(function (e) {
          var s = _this3.containers.get(e);

          if (s) {
            var _t3;

            t(s, (_t3 = {}, _defineProperty(_t3, _this3.opts.rowInvalidClass, false), _defineProperty(_t3, _this3.opts.rowValidatingClass, false), _defineProperty(_t3, _this3.opts.rowValidClass, false), _defineProperty(_t3, "fv-plugins-icon-container", false), _t3));

            _this3.containers.delete(e);
          }
        });
        this.prepareFieldContainer(e.field, s);
      }
    }
  }, {
    key: "onFieldRemoved",
    value: function onFieldRemoved(e) {
      var _this4 = this;

      e.elements.forEach(function (e) {
        var s = _this4.containers.get(e);

        if (s) {
          var _t4;

          t(s, (_t4 = {}, _defineProperty(_t4, _this4.opts.rowInvalidClass, false), _defineProperty(_t4, _this4.opts.rowValidatingClass, false), _defineProperty(_t4, _this4.opts.rowValidClass, false), _t4));
        }
      });
    }
  }, {
    key: "prepareFieldContainer",
    value: function prepareFieldContainer(e, t) {
      var _this5 = this;

      if (t.length) {
        var _s = t[0].getAttribute("type");

        if ("radio" === _s || "checkbox" === _s) {
          this.prepareElementContainer(e, t[0]);
        } else {
          t.forEach(function (t) {
            return _this5.prepareElementContainer(e, t);
          });
        }
      }
    }
  }, {
    key: "prepareElementContainer",
    value: function prepareElementContainer(e, i) {
      var _l2 = "string" === typeof this.opts.rowSelector ? this.opts.rowSelector : this.opts.rowSelector(e, i);

      var a = s(i, _l2);

      if (a !== i) {
        var _t5;

        t(a, (_t5 = {}, _defineProperty(_t5, this.opts.rowClasses, true), _defineProperty(_t5, "fv-plugins-icon-container", true), _t5));
        this.containers.set(i, a);
      }
    }
  }, {
    key: "onElementValidating",
    value: function onElementValidating(e) {
      var s = e.elements;
      var i = e.element.getAttribute("type");

      var _l3 = "radio" === i || "checkbox" === i ? s[0] : e.element;

      var a = this.containers.get(_l3);

      if (a) {
        var _t6;

        t(a, (_t6 = {}, _defineProperty(_t6, this.opts.rowInvalidClass, false), _defineProperty(_t6, this.opts.rowValidatingClass, true), _defineProperty(_t6, this.opts.rowValidClass, false), _t6));
      }
    }
  }, {
    key: "onElementNotValidated",
    value: function onElementNotValidated(e) {
      this.removeClasses(e.element, e.elements);
    }
  }, {
    key: "onElementIgnored",
    value: function onElementIgnored(e) {
      this.removeClasses(e.element, e.elements);
    }
  }, {
    key: "removeClasses",
    value: function removeClasses(e, s) {
      var _t7;

      var i = e.getAttribute("type");

      var _l4 = "radio" === i || "checkbox" === i ? s[0] : e;

      t(_l4, (_t7 = {}, _defineProperty(_t7, this.opts.eleValidClass, false), _defineProperty(_t7, this.opts.eleInvalidClass, false), _t7));
      var a = this.containers.get(_l4);

      if (a) {
        var _t8;

        t(a, (_t8 = {}, _defineProperty(_t8, this.opts.rowInvalidClass, false), _defineProperty(_t8, this.opts.rowValidatingClass, false), _defineProperty(_t8, this.opts.rowValidClass, false), _t8));
      }
    }
  }, {
    key: "onElementValidated",
    value: function onElementValidated(e) {
      var _this6 = this;

      var s = e.elements;
      var i = e.element.getAttribute("type");

      var _l5 = "radio" === i || "checkbox" === i ? s[0] : e.element;

      s.forEach(function (s) {
        var _t9;

        t(s, (_t9 = {}, _defineProperty(_t9, _this6.opts.eleValidClass, e.valid), _defineProperty(_t9, _this6.opts.eleInvalidClass, !e.valid), _t9));
      });
      var a = this.containers.get(_l5);

      if (a) {
        if (!e.valid) {
          var _t10;

          this.results.set(_l5, false);
          t(a, (_t10 = {}, _defineProperty(_t10, this.opts.rowInvalidClass, true), _defineProperty(_t10, this.opts.rowValidatingClass, false), _defineProperty(_t10, this.opts.rowValidClass, false), _t10));
        } else {
          this.results.delete(_l5);
          var _e2 = true;
          this.containers.forEach(function (t, s) {
            if (t === a && _this6.results.get(s) === false) {
              _e2 = false;
            }
          });

          if (_e2) {
            var _t11;

            t(a, (_t11 = {}, _defineProperty(_t11, this.opts.rowInvalidClass, false), _defineProperty(_t11, this.opts.rowValidatingClass, false), _defineProperty(_t11, this.opts.rowValidClass, true), _t11));
          }
        }
      }
    }
  }]);

  return l;
}(e);

export { l as default };